import { makeRetriableGetRequest } from '../api/apiActions';

class VocaboServiceClient {
    static NAME = 'vocabo';

    static URL = '/lanternvoc/v01';

    static RESULT_OPERATION = {
        ADD_RESPONSE: 'add_response',
    };

    static MEASURES = {
        TQVM: 'TQVM',
        FITB: 'FITB',
        BD: 'BD',
    };

    /**
    * Constructs request url to Lantern VOC service based on the passed config object.
    * config may include:
        - measure (TQVM, FITB, BD)
        - grade
        - period
    */
    static constructFormEndpoint({ measure, grade, period, language } = {}) {
        let endpoint = `${VocaboServiceClient.URL}/forms`;
        const params = [];

        if (measure) {
            params.push(`measure=${measure}`);
        }
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (language) {
            params.push(`language=${language}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Sends GET request to results endpoint with provided parameters
     * @param {str} measure - (optional) specified measure of Vocabulary asessment
     * @param {str} grade - (optional) student's grade
     * @param {str} period - (optional) BOY | MOY | EOY
     * @param {str} language - (optional) current language
     * @returns {JSON} server response
     */
    static getForm = (measure, grade, period, language, retryActionName) => dispatch => {
        const config = {
            measure,
            grade,
            period,
            language,
        };

        const endpoint = VocaboServiceClient.constructFormEndpoint(config);
        return dispatch(makeRetriableGetRequest(endpoint, retryActionName));
    };

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({
        studentId,
        measure,
        grade,
        period,
        schoolYear,
        language,
    } = {}) {
        let endpoint = `${VocaboServiceClient.URL}/results`;
        const params = [];
        if (measure) {
            params.push(`measure=${VocaboServiceClient.MEASURES[measure]}`);
        }
        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (language) {
            params.push(`language=${language}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for creating result
     */
    static constructCreateResultEndpoint() {
        return `${VocaboServiceClient.URL}/results`;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructSaveResultEndpoint(resultId) {
        return `${VocaboServiceClient.URL}/results/${resultId}`;
    }
}

export default VocaboServiceClient;
